export default __webpack_public_path__ + "static/media/duckoys_thumb.c556f93a.jpg";